import React, { useEffect, useState } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import Brands1 from "../brands/Brands1";
import { FaArrowRight, FaArrowLeft, FaLongArrowAltRight, FaPlay} from "react-icons/fa";
import Slider from "react-slick";
import "aos/dist/aos.css";
import axios from "axios";
import { Link } from "react-router-dom";
import AOS from "aos";
const SocialMediaMarketing = () => {

 useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

const [openFAQ, setOpenFAQ] = useState(0);
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaArrowRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaArrowLeft />
  </div>
);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    url: "/social-media-marketing",
    manager_id: "",
    pipeline_id: "14",
    source_id: "36",
    name: "New Get Proposal Request Received | ISOLS Group Website | Social Media Marketing Page",
    contact_name: "",
    contact_company: "",
    contact_email: "",
    contact_phone: "",
    description: "",
    nspm: "",
    flowlu_host: "https://erp.isolsgroup.com/"
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
     setLoading(true);
    setMessage("");

      try {
    
          const response = await axios.post(
          "https://erp.isolsgroup.com/api/v1/module/crm/leads/web_lead?id=101591&api_token=a1b962d0c1fb87354b47c32c88929ea2",
          formData,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data && response.data._resultMessage) {
          setMessage(
            response.data._resultMessage.replace("{{ID}}", response.data.id)
          );
        } else {
          setMessage("Form submitted successfully!");
        }


      }  catch (error) {
        console.error(error);
        setMessage("Error submitting form. Please try again later.");
      } finally {
        setLoading(false);
      }

  };
  const faqs = [
  {
    question: "What exactly is Social Media Marketing (SMM)?",
    answer:
      "Social Media Marketing (SMM) means using platforms like Facebook, Instagram, and Twitter to showcase your business. It helps you connect with people, spread the word about your Business, and get more visitors to your website.",
  },
  {
    question: "Why should I care about SMM for my business?",
    answer:
      "SMM is where people hang out online. Being there helps you talk to your customers directly, show off your brand, and even get more folks interested in what you offer.",
  },
  {
    question: "Which social media sites should I focus on?",
    answer:
      "The cool ones like Facebook, Instagram, Twitter, LinkedIn, Pinterest, and TikTok. But you don't need them all – just the ones that make sense for your people.",
  },
  {
    question: "How does SMM help my brand shine online?",
    answer:
      "By sharing fun and important posts and much more, talking to folks, and using things like hashtags and contests. It's like waving your brand flag online!",
  },
  {
    question: "Are those paid ads on social media worth it?",
    answer:
      "Totally! They help you reach specific folks, show off your Business, and even get more people to visit your website or buy your things.",
  },
  {
    question: "Can I tell if my SMM is actually working?",
    answer:
      "Yep! Look at things like how many people liked, commented, and clicked on your Business. That's how you know if folks are into what you're saying.",
  },
];

const testimonials = [
  {
    name: "Arpan Ghosh",
    text: "The job which I appointed them was nicely done. The only thing I was concerned about was if they were authentic or not. But everything turned out good and these guys are 100% authentic. Highly recommended by me. I would love to work with these guys in the near future.",
    img: "/images/male-user.png",
  },
  {
    name: "Zeus",
    text: "I took the e-mail marketing service from them. They were highly dedicated towards their work and always kept me updated. After the splendid service they gave me for e-Mail marketing, I asked them for the Search Engine Optimization service as well. It also turned out well and I can actually see a change in my website. The reach of my website seems to be increased and I can also see new audiences checking my website. 5 stars to their work. 😉",
    img: "/images/male-user.png",
  },
  {
    name: "Mr. Badshah",
    text: "I appointed this company for e-mail marketing. To be honest, they did a splendid job. They completely nailed it. I can see the difference in my e-commerce business. If you are looking for a company for the e-mail marketing service, you can choose Digital India Leader blindfolded. 5 stars for there service.",
    img: "/images/male-user.png",
  },
  {
    name: "Sonia Sharma",
    text: "Best in class service. I hired them for a Search Engine Optimization service, they did a splendid job. I can legit see the positive response on my website and can see the reach has been increased in a drastic manner. Cheers to DIL team.",
    img: "/images/female-user.png",
  },
  {
    name: "Jason D. Sealey",
    text: "I hired them for PPC marketing. They provided me with good service. I am happy personalised attitude of dealing. Thanks to these people, my returns has increased and I can finally see a positive response on my website.",
    img: "/images/male-user.png",
  },
  ];



  return (
    <div>
      <BreadcrumbsHeader
        title="Social Media Marketing"
        backgroundImage="/images/breadcrumbs/digital-marketing-cover.jpg"
      />

      {/* ======= MAIN SECTION ======= */}
      <section className="section-home-secondary" id="enquire_now">
        <div className="b-home-about relative">
          {/* Side Vertical Text */}
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">
              ISOLS Group
            </span>
            <span className="vertical-text-additional color-add-2 text-uppercase">
              DM
            </span>
          </div>

          <div className="container">
            <div className="row">
              {/* ===== LEFT SIDE ===== */}
              <div className="col-xs-12 col-sm-6">
                <div
                  className="b-mod-heading fade-down"
                  style={{ marginBottom: "10px" }}
                >
                  <p
                    className="first-heading font-secondary"
                    style={{ fontSize: "20px", fontWeight: 600 }}
                  >
                    SOCIAL MEDIA
                  </p>
                  <h2 className="heading-line line-right custom Color customPseudoElBg">
                    <strong>MARKETING SERVICES</strong>
                  </h2>
                  <p className="second-heading font-additional">
                    OUR SOCIAL MEDIA MARKETING STRATEGIES WILL MAKE YOUR BRAND
                    #TRENDING!
                  </p>
                  <p className="second-heading font-additional">
                    With ISOLS Group, the best Social Media Marketing Company,
                    make your social media presence count!
                  </p>
                </div>

                <div className="b-text">
                  <p>
                    <strong>LISTEN</strong>
                    <br />
                    We work with you, for you. We start with understanding your
                    target audience and their focus of interest.
                  </p>
                  <p>
                    <strong>PLAN</strong>
                    <br />
                    Our social media marketing services are customised just for
                    you. We start from the scratch by understanding your brand’s
                    objectives, then plan wisely based on it and weave intricate
                    and powerful brand stories.
                  </p>
                  <p>
                    <strong>EXECUTE</strong>
                    <br />
                    We by weaving strong brand stories aim at a significant
                    boost of your brand’s exposure and its sales!
                  </p>
                  <p>
                    <strong>OPTIMIZE</strong>
                    <br />
                    At ISOLS Group, our team constantly keeps an eye on the
                    outcomes and eventually comes up with the best social media
                    optimisation strategies that can be implemented.
                  </p>
                </div>
              </div>

              {/* ===== RIGHT SIDE FORM ===== */}
              <div className="col-xs-12 col-sm-6 fade-left">
                <div
                  className="footer-form fade-down"
                  id="contact-form"
                  style={{ visibility: "visible", animationName: "fade-down" }}
                >
                
                    <form onSubmit={handleSubmit} className="b-form-footer">
      <h2 className="footer-form-title" style={{ color: "#000", fontSize: 20 }}>
        SEEK EXPERT'S ADVICE & GET PROPOSAL
      </h2>

      {/* Hidden fields */}
      <input type="hidden" name="url" value={formData.url} />
      <input type="hidden" name="manager_id" value={formData.manager_id} />
      <input type="hidden" name="pipeline_id" value={formData.pipeline_id} />
      <input type="hidden" name="source_id" value={formData.source_id} />
      <input type="hidden" name="name" value={formData.name} />
      <input type="hidden" name="flowlu_host" value={formData.flowlu_host} />
      <textarea name="nspm" style={{ display: "none" }}></textarea>

      <div className="flowlu-row">
        <input
          type="text"
          name="contact_name"
          className="flowlu-input"
          placeholder="Your Name*"
          required
          onChange={handleChange}
        />

        <input
          type="text"
          name="contact_company"
          className="flowlu-input"
          placeholder="Your Company Name*"
          required
          onChange={handleChange}
        />

        <input
          type="text"
          name="contact_email"
          className="flowlu-input"
          placeholder="Email Address*"
          required
          onChange={handleChange}
        />

        <input
          type="text"
          name="contact_phone"
          className="flowlu-input"
          placeholder="Mobile Number"
          required
          onChange={handleChange}
        />

        <textarea
          name="description"
          rows="5"
          className="flowlu-input"
          placeholder="Type Your Query"
          style={{width: "100%", height: "146px", borderRadius: "0px"}}
          required
          onChange={handleChange}
        ></textarea>
      </div>

      <div className="flowlu-row flowlu-row-submit">
        <button
          type="submit"
          className="flowlu-submit btn-default-arrow"
          style={{ marginTop: 30 }}
          disabled={loading}
        >
          <i className="fa fa-long-arrow-right"></i>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>

        {message && (
            <div
              className="flowlu-notification"
              style={{ marginTop: "10px", fontWeight: "bold", color: message.includes("Error") ? "red" : "green" }}
            >
              {message}
            </div>
          )}

    </form>



                </div>
              </div>
            </div>

            {/* ===== OVERVIEW ===== */}
            <div className="row">
              <h2
                className="vc_custom_heading"
                style={{
                  fontSize: "48px",
                  color: "#ff9600",
                  lineHeight: "1.2",
                  textAlign: "center",
                  fontFamily: "Raleway",
                  fontWeight: 700,
                  padding: "10px 0 22px",
                }}
              >
                SOCIAL MEDIA MARKETING OVERVIEW
              </h2>
            </div>

           <div className="b-services-holder">
  <div className="row">
    {/* Card 1 */}
    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-left"
      style={{ visibility: "visible", animationName: "fade-left" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/social-media-marketing.png"
            alt="Search Engine Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            GROW YOUR BRAND'S VIEWS AND CONNECT WITH THEM.
          </h6>
          <p>
            To make your sales reach the peak all you need is maximum exposure.
            At our Social Media Marketing Agency, ISOLS Group with a team of
            creative and strategic experts, we make sure your brand's voice is
            heard!
          </p>
        </div>
      </div>
    </div>

    {/* Card 2 */}
    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-down"
      style={{ visibility: "visible", animationName: "fade-down" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/viral-marketing.png"
            alt="brand story icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Tell your brand story
          </h6>
          <p>
            Every brand has their story, their own journey. And the best way to
            connect with your audience is through the story that they can relate
            to, a journey they want to be a part of! At ISOLS Group, we provide
            the best social media marketing services where we work on your
            objectives and focus on strong and powerful storytelling.
          </p>
        </div>
      </div>
    </div>

    {/* Card 3 */}
    <div
      className="col-md-4 col-xs-12 col-sm-4 wow slideInRight"
      style={{ visibility: "visible", animationName: "slideInRight" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/content-marketing.png"
            alt="Content Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Develop viral content
          </h6>
          <p>
            The best way to be on the top of the social ladder is to GO VIRAL!
            We, with our team of experts with their immense knowledge of the
            workings of social media will make sure that your brand is
            #Trending.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row">
    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-left"
      style={{ visibility: "visible", animationName: "fade-left" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/smm.png"
            alt="Video Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Identify the right platforms
          </h6>
          <p>
            We work closely with you and understand your brand's objectives and
            target audience. With our social media marketing services and
            expertise in various social media platforms such as Instagram,
            YouTube, Facebook and Twitter, we plan accordingly on which social
            media campaign to focus on primarily, based on its crowd.
          </p>
        </div>
      </div>
    </div>

    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-up"
      style={{ visibility: "visible", animationName: "fade-up" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/video-marketing.png"
            alt="Influencer Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Design
          </h6>
          <p>
            Building brand awareness is the kick start to increase your brand's
            sales. That's not the end! Social media with its global reach makes
            it possible to reach the potential audience and with efficient
            planning those can be turned into successful clients.
          </p>
        </div>
      </div>
    </div>

    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-right"
      style={{ visibility: "visible", animationName: "fade-right" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/viral-marketing.png"
            alt="Viral Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Convert potential leads to successful customers!
          </h6>
          <p>
            We, at ISOLS Group with our social media marketing strategies focus
            on connecting with the target audience who are the potential leads
            and transform them into successful and happy customers. We make sure
            your brand's journey captivates them and eventually they become a
            part of it.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row">
    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-right"
      style={{ visibility: "visible", animationName: "fade-right" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/ful-funnel.png"
            alt="Online Reputation Management icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Full-funnel marketing
          </h6>
          <p>
            Our social media experts, through our full-funnel marketing
            strategies approach the social media audience, generate interest
            amongst them, engage with them to make them consider your brand and
            finally encourage them to take action. Boom!
          </p>
        </div>
      </div>
    </div>

    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-right"
      style={{ visibility: "visible", animationName: "fade-right" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/email-marketing.png"
            alt="Email Marketing icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Native
          </h6>
          <p>
            We make sure through native advertising in various social media
            platforms like Facebook, Twitter, Instagram your brand consistently
            remains in the spotlight and gains successful leads.
          </p>
        </div>
      </div>
    </div>

    <div
      className="col-md-4 col-xs-12 col-sm-4 fade-right"
      style={{ visibility: "visible", animationName: "fade-right" }}
    >
      <div className="b-services-item">
        <div className="services-icon">
          <img
            src="/images/solution-services-icons/payonclick.png"
            alt="Pay Per Click icon"
          />
        </div>
        <div className="services-text">
          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
            Ad Platforms
          </h6>
          <p>
            ISOLS Group provides the best social media advertising for business
            in India. Our Social media marketing services includes promoting
            your brand through advertisement in various platforms which results
            in your brand’s maximum exposure.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


            {/* ===== BOTTOM PARAGRAPH ===== */}
            <div className="row">
              <center>
                <div className="p-sz">
                  <p style={{ fontSize: "17px" }}>
                    With the ever-growing social media family that houses
                    potential audiences, it might be a tricky job to keep your
                    brand in the limelight. As the media evolves along with it
                    your target audience and their interests shift too. In order
                    to keep pace with it, all you need is the best social media
                    marketing services and that’s why we are here!
                  </p>
                </div>
              </center>
            </div>

            {/* ===== VIDEO SECTION ===== */}
            <section className="section-about">
              <div className="container">
                <div className="b-home-video-block">
                  <div className="container-fluid">
                    <div
                      className="col-xs-12 col-sm-12 col-md-12 col-lg-12 left-side fade-left"
                      style={{ visibility: "visible" }}
                    >
                      <div className="b-video-holder text-center">
                        <Link
                          className="video-image playVideo1"
                          to="#"
                          data-toggle="modal"
                          data-target="#myModal"
                        >
                          <FaPlay className="demo-icon play-icon" /><br></br>
                          <span className="video-title">play the video</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <section>
          <div className="container" style={{ padding: "60px 0" }}>
        <div className="row">
      
          {/* LEFT SIDE – FAQ */}
          <div className="col-lg-6 col-md-12">
            <section className="faq-section">
              <h2 className="faq-title">ASK YOUR QUERIES?</h2>
              <p className="faq-subtitle">SEO FAQs</p>
      
              <div className="faq-box">
                {faqs.map((item, index) => (
                  <div
                    key={index}
                    className={`faq-item ${openFAQ === index ? "active" : ""}`}
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  >
                    <div className="faq-question">
                      <span className="faq-icon">
                        {openFAQ === index ? "✖" : "➕"}
                      </span>
                      {item.question}
                    </div>
      
                    {openFAQ === index && (
                      <div className="faq-answer">{item.answer}</div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          </div>
      
          {/* RIGHT SIDE – TESTIMONIALS */}
          <div className="col-lg-6 col-md-12">
            <section className="testimonial-section">
        <h2 className="testimonial-title">What our clients say about us</h2>
      
        <Slider
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={3000}
          arrows={true}
          nextArrow={<NextArrow />}
          prevArrow={<PrevArrow />}
        >
          {testimonials.map((item, i) => (
            <div key={i} className="testimonial-card">
              <img src={item.img} alt="" className="testimonial-img" />
              <h4 className="testimonial-name">{item.name}</h4>
              <p className="testimonial-text">{item.text}</p>
            </div>
          ))}
        </Slider>
      </section>
      
          </div>
      
        </div>
      </div>
      
          </section>
      
      
                <section
            className="section-about1 sectionn"
            style={{ paddingBottom: "100px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <h2
                    style={{
                      fontSize: "25px",
                      color: "#ff9600",
                      lineHeight: 1.2,
                      textAlign: "center",
                      fontFamily: "Raleway",
                      fontWeight: 700,
                      fontStyle: "normal",
                      padding: "0 0 30px 0",
                      textTransform: "uppercase",
                    }}
                    className="vc_custom_heading vc_custom_1490112359046"
                  >
                    What Our Client Feel About Us
                  </h2>
      
                  <div className="row">
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/ofWi6TePZQo"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 1"
                      ></iframe>
                    </div>
      
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/3iJH9el9dzQ"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 2"
                      ></iframe>
                    </div>
      
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/Hfh01auRGAw"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 3"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

      <Brands1 />
      <div className="b-plans-holder section-about1">
            <div className="container">
              <center>
                <div className="p-sz" style={{ marginTop: "20px" }}>
                  <p style={{ fontSize: "17px" }}>
                    <Link
                      to="https://www.digitalindialeader.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLongArrowAltRight style={{ marginRight: "5px" }} />
                      Know more
                    </Link>{" "}
                    about various digital marketing solutions & services offered by
                    Digital India Leader - A digital marketing wing of ISOLS Group
                  </p>
                </div>
              </center>
            </div>
          </div>
    </div>
  );
};

export default SocialMediaMarketing;
